import React from 'react'
import { Form, Radio } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { EXECUTION_TYPES } from '../../utils/constants'

const ExecutionTypeSelector: React.FC = () => (
  <Wrapper>
    <div className="section-title">
      {t('任务执行配置')}
      <div className="section-bar" />
    </div>
    <Form.Item
      label={t('执行类型')}
      name="schedulerType"
      required
      style={{ marginLeft: 34, marginBottom: 0 }}
    >
      <Radio.Group>
        {EXECUTION_TYPES.map(type => (
          <Radio.Button key={type.value} value={type.value}>
            {type.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </Form.Item>
  </Wrapper>
)

export default ExecutionTypeSelector

const Wrapper = styled.div`
  margin-bottom: 24px;

  .section-title {
    font-weight: 500;
    color: #1d2129;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 88px;
      height: 6px;
      background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
      border-radius: 0px 86px 0px 100px;
      margin-top: 8px;
    }

    .section-bar {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background: #ebeaf9;
      margin-top: 4px;
      margin-bottom: 20px;
    }
  }
`
